import switzerlandTakesCare from 'assets/images/switzerlandTakesCare.jpeg';
import switzerlandTakesCareOverview from 'assets/images/booksOverview/switzerlandTakesCare.png';

import {
  ONLY_PURCHASE,
  LOGIN,
  ADDRESS,
  PAYMENT,
  PREMIUM_OFFER,
  THANKS,
  PASSWORD,
  FIRST_NAME,
  LAST_NAME,
  ZIP_CODE,
  CITY,
  COUNTRY,
  EMAIL,
  PRINTED_BOOK,
  SMART_BOOKS,
} from '../const';

const switzerlandCaresFor = {
  book: {
    id: 'die-schweiz-sorgt-vor',
    format: SMART_BOOKS,
    title: 'Switzerland takes care',
    subtitle: 'The three pillars of retirement provision',
    price: [36, 43],
    introductions: [
      'People are beginning to realise',
      ['Required reading for responsible citizens', 'Prof Dr Heinz Zimmermann'],
      ['In an ageing society, knowledge about pension provision is of central importance', 'Prof Dr Christoph Schaltegger'],
    ],
    image: switzerlandTakesCare,
    overviewImg: switzerlandTakesCareOverview,
  },
  bookIds: [34, 35, 36],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [PRINTED_BOOK],
  purchases: [
    {
      id: 1,
      name: 'Fintool Premium Subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [36, 43],
            propositions: ['Printed book Switzerland takes care'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [36, 43],
            propositions: ['Printed book Switzerland takes care'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/2',
          nextStep: 2,
        }),
        [PAYMENT]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [36, 43],
            propositions: ['Printed book Switzerland takes care'],
          },
          form: { withPromoCode: false },
          navigation: '2/2',
          prevStep: 1,
          nextStep: 3,
          shouldSignUp: false,
          subscribeId: null,
          productId: 36,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 2,
      name: 'Fintool Basic subscriber',
      tasks: {
        [LOGIN]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [43],
            propositions: ['Printed book Switzerland takes care'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [EMAIL, PASSWORD],
            submitButton: 'Login',
            showAdb: false,
          },
          nextStep: 1,
        }),
        [ADDRESS]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF',
            priceValues: [43],
            propositions: ['Printed book Switzerland takes care'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [ADDRESS, ZIP_CODE, CITY, COUNTRY],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/3',
          nextStep: 2,
        }),
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Fintool Basic subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book Switzerland takes care', '12 months Fintool-Premium'],
          },
          form: {
            title: 'Switch to Fintool-Premium now and get the book for free',
            priceDescription: 'If you decide now on a Fintool premium annual subscription for',
            priceValues: [100, 143],
            yesButton: 'Yes, buy for',
            noButton: 'Continue without Premium',
          },
          navigation: '2/3',
          prevStep: 1,
          nextStep: 3,
        }),
        [PAYMENT]: (wishPremium) => ({
          banner: {
            title: wishPremium ? 'Fintool Premium Subscriber' : 'Fintool Basic subscriber',
            price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
            priceValues: wishPremium ? [100, 143] : [43],
            propositions: wishPremium
              ? ['Printed book Switzerland takes care', '12 months Fintool-Premium']
              : ['Printed book Switzerland takes care'],
          },
          form: { withPromoCode: false },
          navigation: '3/3',
          prevStep: 2,
          nextStep: 4,
          shouldSignUp: false,
          subscribeId: wishPremium ? 6 : null,
          productId: wishPremium ? 35 : 34,
        }),
        [THANKS]: () => ({
          form: {
            title: 'Your order is on its way',
            description:
              'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.',
            button: { name: 'To the Fintool Academy', url: '/akademie' },
          },
        }),
      },
    },
    {
      id: 3,
      name: 'Not a Fintool subscriber and would like to order the book',
      tasks: {
        [ONLY_PURCHASE]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF',
            priceValues: [43],
            propositions: ['Printed book Switzerland takes care'],
          },
          form: {
            showSubscribeDescription: false,
            inputs: [FIRST_NAME, LAST_NAME, ADDRESS, ZIP_CODE, CITY, COUNTRY, EMAIL],
            submitButton: 'Continue',
            showAdb: false,
          },
          navigation: '1/3',
          nextStep: 1,
        }),
        [PREMIUM_OFFER]: () => ({
          banner: {
            title: 'Not a Fintool subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: [
              'Printed book Switzerland takes care',
              'Regularly new videos by e-mail',
              'Unlimited access to video library',
              'Access to the entire course offering',
              'Unlimited access to the forums',
              'Knowledge reviews',
              'No advertising breaks',
            ],
          },
          form: {
            title: 'Get Fintool Premium now and get the book for free',
            priceDescription: 'If you decide now on a Fintool premium annual subscription for',
            priceValues: [100, 143],
            yesButton: 'Yes, buy for',
            noButton: 'Order book only',
          },
          navigation: '2/3',
          prevStep: 0,
          nextStep: [2, 3],
        }),
        [PASSWORD]: () => ({
          banner: {
            title: 'Fintool Premium Subscriber',
            price: 'PriceCHF/insteadCHF',
            priceValues: [100, 143],
            propositions: ['Printed book Switzerland takes care', '12 months Fintool-Premium'],
          },
          form: {
            title: 'Set a password for your Fintool account',
            showSubscribeDescription: false,
            inputs: [PASSWORD],
            submitButton: 'Register',
            showAdb: true,
          },
          navigation: '3/4',
          prevStep: 1,
          nextStep: 3,
        }),
        [PAYMENT]: (wishPremium) => ({
          banner: {
            title: wishPremium ? 'Fintool Premium Subscriber' : 'Not a Fintool subscriber',
            price: wishPremium ? 'PriceCHF/insteadCHF' : 'PriceCHF',
            priceValues: wishPremium ? [100, 143] : [43],
            propositions: wishPremium
              ? ['Printed book Switzerland takes care', '12 months Fintool-Premium']
              : ['Printed book Switzerland takes care'],
          },
          form: { withPromoCode: false },
          navigation: wishPremium ? '4/4' : '3/3',
          prevStep: wishPremium ? 2 : 1,
          nextStep: 4,
          shouldSignUp: wishPremium,
          subscribeId: wishPremium ? 6 : null,
          productId: wishPremium ? 35 : 34,
        }),
        [THANKS]: (wishPremium) => ({
          form: {
            title: 'Your order is on its way',
            description: wishPremium
              ? 'Thank you for your order. The book is on its way to you. Take advantage of the Fintool Premium offer and expand your money knowledge in one of our courses.'
              : 'Would you like to get to know Fintool? Take a look at our latest videos in the video studio',
            button: {
              name: wishPremium ? 'To the Fintool Academy' : 'To the video studio',
              url: wishPremium ? '/akademie' : '/videos',
            },
          },
        }),
      },
    },
  ],
};

export default switzerlandCaresFor;
